import { useCallback, type MouseEvent } from "react";

export const useOnMouseEventPreventDefaultHandler = () =>
  useCallback((e: MouseEvent) => {
    e.preventDefault();
    e.stopPropagation();
  }, []);
